import React from 'react'
import './Checkout.css'
import { useStateValue } from './StateProvider'
import CheckoutProduct from './CheckoutProduct'
import Subtotal from './Subtotal'

const Checkout = () => {
    const [{basket,user}]=useStateValue();
    return (
        <div className='checkout'>
            <div className='checkout_left'>
            <img src="https://images-eu.ssl-images-amazon.com/images/G/31/gateway-2015/amazonshop/Desktop_Banner_Recruitment_Website.jpg" alt="" className="checkout_adds" />
        
        {basket?.length===0 ? (
            <div>
                <h2>Your shopping basket is Empty</h2>
                <p>Youn have np items in your basket .To buy one or "Add to Basket " next to the item... 🚀🚀</p>
            </div>
        ) : (
            <div>
                <h3> Hello {user?.email}</h3>
                <h2 className='checkout_title'>Your Shoping Card</h2>
                {/* list out  all of the products */}
                {basket?.map(item=>(
                        <CheckoutProduct 
                        id={item.id}
                        title={item.title}
                        image={item.image}
                        price={item.price}
                        rating={item.rating}
                    />
                ))}
                
            </div>
        )}
        </div>
        
        <div className="checkout_right">
        {basket.length>0 && (
                <Subtotal />
               
            )}   
           </div>

            


        </div>
    )
}

export default Checkout
